import "./MainApp.css";
import "./AuthorPage.css";
import { useState, useEffect } from "react";
import AuthorDesc from "./AuthorDesc/AuthorDesc";
import AuthorStihList from "./AuthorStihList/AuthorStihList";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "bootstrap/dist/css/bootstrap.min.css";
import ky from "ky";
import { useParams, useNavigate } from "react-router-dom";
import BackButton from "./Parts/BackButton";
import Navigation from "./Parts/Navigation";
import Button from "./Parts/Button";
import ErrorPage from "./error-page";
import {Helmet} from "react-helmet";
import Loading from "./Loading";
import Animation from "./Animation";

function AuthorPage() {
  let { authorId } = useParams();
  let navigate = useNavigate();
  let [author, setAuthor] = useState({});
  let [isLoading, setIsLoading] = useState(true);
  let [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    ky
      .get("/api/author/" + authorId, { timeout: 20000 })
      .json()
      .then((response) => {
        setAuthor(response);
      })
      .finally(() => setIsLoading(false))
      .catch((error) => {
        console.log(error);
        setIsError(true);
      });
  }, []);

  function MetaTags() {
    if (!isLoading) {
      return(
        <Helmet>
        <meta property="og:type" content="article" />
        <meta property="og:title" content={author.name} />
        <meta property="og:description" content="Все стихотворения автора" />
        <meta property="og:image" content={author.photo} />
  
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={author.name} />
        <meta name="twitter:description" content="Все стихотворения автора" />
        <meta name="twitter:image" content={author.photo} />
        
        <meta name="description" content={author.name} />
      </Helmet>
      )
    } else {
      return
    }
  }

  function handleGuessClick() {
    navigate("/author/" + authorId + "/fortune");
  }

  function PageContent() {
    if (isLoading) {
        return (<Loading />)
    } else {
      // Fix bug on iOS PWA https://github.com/vuejs/vue/issues/5533
      window.scrollTo(0, 1);
      window.scrollTo(0, 0);
      
      return (
        <div>
          <AuthorDesc description={author.description} photo={author.photo} name={author.name}/>
          <div className="buttonContainer">
            <Button href={"/author/" + author.id + "/feed"} text="Читать лентой" />
            <button className="guessButton" onClick={handleGuessClick}>
              Погадать
            </button>
          </div>
          <AuthorStihList />
        </div>
      )
    }
  }

  if (isError) return <ErrorPage />

  return (
    <div className="List">
      <BackButton />
      <Navigation />
      <MetaTags />
      <Container fluid>
      <Animation>
        <Row className="justify-content-center animated">
          <Col xs="auto" md="6" lg="5" xl="4">
              <PageContent />
          </Col>
        </Row>
        </Animation>
      </Container>
    </div>
  );
}

export default AuthorPage;
